import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import { APIS_KEYS } from "../../apis-keys"
import { IPropsGetMasterData, IResponseGetMasterData } from "./types"
import { GetMasterDataUrl } from "../../../utils/constants"
import type { AxiosInstance, AxiosResponse } from "axios"
import { useApi } from "../../useApi"

async function getMasterData(
	{ ...rest }: IPropsGetMasterData,
	apiPrivate: AxiosInstance
) {
	try {
		const response: AxiosResponse<IResponseGetMasterData> =
			await apiPrivate.get(`${GetMasterDataUrl}`, {
				params: rest,
			})
		return response.data
	} catch (error: any) {
		console.log(error)
		throw new Error("something went wrong")
	}
}

export function useGetMasterData(
	data: IPropsGetMasterData,
	options?:
		| Omit<
				UseQueryOptions<
					IResponseGetMasterData,
					unknown,
					IResponseGetMasterData
				>,
				"queryKey" | "queryFn"
		  >
		| undefined
) {
	const { apiPrivate } = useApi()
	return useQuery({
		queryKey: [APIS_KEYS.GETCALENDERDATA, ...Object.values(data)],
		queryFn: () => getMasterData(data, apiPrivate),
		...options,
	})
}
